import React from "react";
import { Box } from "digiwash-components";
import Header from "../components/AppHeader";
import PageContainer from "../components/PageContainer";
import useBack from "../hooks/useBack";
import EditProfile from "../containers/EditProfile";
import useProfile from "../ducks/user/hooks/useProfile";
import { Helmet } from "react-helmet";
import HeaderContainer from "../containers/HeaderContainer";

function EditUserProfileInfo() {
  let back = useBack();
  let { data } = useProfile();

  return (
    <>
      <Helmet>
        <title>ویرایش اطلاعات پروفایل | دیجی واش</title>
      </Helmet>
      <PageContainer
        extraSpaceFromBottom={true}
        bg="common.white"
        insideBeignScrollView={
          <HeaderContainer>
            <Header title="ویرایش اطلاعات" onBack={back} />
          </HeaderContainer>
        }
      >
        <Box pt="xxl" px="xxl">
          <EditProfile data={data} />
        </Box>
      </PageContainer>
    </>
  );
}

export default EditUserProfileInfo;
